import styled from 'styled-components';

export const StyledMetricsContainer = styled.div`
  margin-top: 8px;
`;
